import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { Row, Col } from "react-flexbox-grid";
import { FieldSelect, FieldText, FieldDatePicker } from "../../Fields";
import { Button } from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faFilter,
  faAngleDown,
  faAngleUp,
  faAngleDoubleUp,
  faAngleDoubleDown,
  faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import { getFilterSearch } from "../../../redux/selectors/Context";
import {
  getCodigueraContext,
  getCodigueraRAM,
} from "../../../redux/selectors/Context";
import {
  getProductosFilterSearch,
  setLoad,
  setEventFilters,
} from "../../../redux/actions/context";
import { showError } from "../../../redux/actions/error";
import {
  url_getProductFilters,
  url_getPrincipioActivoByFamilia,
} from "../../../api/urls";
import "../style.css";
import api from "../../../api";
import moment from "moment-timezone";
import ExcelJS from "exceljs";
import { CSVLink } from "react-csv";
import { argv0 } from "process";

class FilterERSearch extends Component {
  state = {
    hiddenFilters: false,
    countries: [],
    laboratories: [],
    companies: [],
    products: [],
    NombreComercial: [],
    pActive: [],
    dateIniCre: null,
    dateEndCre: null,
    dateIniMod: null,
    dateEndMod: null,
  };

  componentDidMount = async () => {
    if (this.state.countries.length > 0) {
      this.props.setLoad(false);
    }

    if (Object.keys(this.props.eventFilters).length) {
      const newState = {};
      if (this.props.eventFilters.country) {
        this.setState({
          companies: this.getCompanies(String(this.props.eventFilters.country)),
        });
      }
      if (this.props.eventFilters.company) {
        this.setState({
          laboratories: this.getLaboratories(
            Number(this.props.eventFilters.company)
          ),
        });
      }
      if (this.props.eventFilters.laboratory) {
        try {
          const data = await this.getProducts(
            Number(this.props.eventFilters.laboratory)
          );
          newState.products = data;
        } catch {
          newState.products = [];
        }

        if (Object.keys(newState).length) {
          this.setState(newState);
        }
      }
    }
  };
  componentWillMount = async () => {
    const { filters } = this.props;
    this.setState({
      countries: filters !== null ? filters.Countries : [],
    });
    const products = await api.get(url_getProductFilters(0));
    this.setState({ products: products.data });
    const pa = await api.get(url_getPrincipioActivoByFamilia(0));
    this.setState({ pActive: pa.data });
    if (this.state.countries.length > 0) {
      this.props.setLoad(false);
    } else {
      this.props.setLoad(true);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { filters } = this.props;
    if (prevProps.filters === null && filters !== null) {
      this.setState({
        countries: filters.Countries,
      });
    }
    if (this.state.countries.length > 0) {
      this.props.setLoad(false);
    } else {
      this.props.setLoad(true);
    }
  }

  getCompanies = (companyId) => {
    return companyId !== "none"
      ? this.props.filters.Companies.filter(
          (l) => l.CountryCode === companyId
        ) || []
      : this.props.filters.Companies;
  };

  handleChangeCountrie = (e) => {
    const { value } = e.target;
    let cnias = [];
    let labs = [];
    let prod = [];
    if (value !== "none") {
      const id = String(value);
      cnias = this.getCompanies(id);
      const countryID = cnias[0].CountryId;
      labs = countryID
        ? this.props.filters.Laboratories.filter(
            (l) => l.CountryId === countryID
          ) || []
        : this.props.filters.Laboratories;
      this.setState({ companies: cnias, laboratories: labs, products: prod });
      this.props.setEventFilters({
        ...this.props.eventFilters,
        country: value,
      });
    } else {
      this.setState({ companies: [], laboratories: [], products: [] });
    }
  };

  getLaboratories = (companyId) => {
    const id = companyId;
    return id > 0
      ? this.props.filters.Laboratories.filter((l) => l.CompanyId === id) || []
      : this.props.filters.Laboratories;
  };

  handleChangeCompany = (e) => {
    const { value } = e.target;
    let labs = [];
    if (value !== "none") {
      const id = Number(value);
      labs = this.getLaboratories(Number(value));
      this.props.setEventFilters({ ...this.props.eventFilters, company: id });
      this.setState({ laboratories: labs });
    } else {
      this.setState({ laboratories: [], products: [] });
    }
  };

  getProducts = async (laboratoryId) => {
    const response = await api.get(url_getProductFilters(laboratoryId));
    return response.data || [];
  };

  getPActive = async (famId) => {
    const response = await api.get(url_getPrincipioActivoByFamilia(famId));
    return response.data || [];
  };

  handleChangeLab = async (e) => {
    const { value } = e.target;
    if (value !== "none") {
      const id = Number(value);
      this.props.setEventFilters({
        ...this.props.eventFilters,
        laboratory: id,
      });
      try {
        const products = await this.getProducts(id);
        this.setState({ products: products });
      } catch (error) {
        this.prop.showError(error);
        this.setState({ products: [] });
      }
    } else {
      this.setState({ products: [] });
    }
  };
  handleHiddenFilters = () => {
    this.setState({ hiddenFilters: !this.state.hiddenFilters });
  };

  handleProduct = async (e) => {
    const { value } = e.target;
    if (value !== "none") {
      this.props.setEventFilters({
        ...this.props.eventFilters,
        NombreComercial: value,
      });
    }
  };

  handlePActive = (e) => {
    const { value } = e.target;
    this.props.setEventFilters({ ...this.props.eventFilters, pActive: value });
  };

  handleStatus = (e) => {
    const { value } = e.target;
    this.props.setEventFilters({ ...this.props.eventFilters, status: value });
  };

  handleTypeRAM = (e) => {
    const { value } = e.target;
    this.props.setEventFilters({ ...this.props.eventFilters, typeRAM: value });
  };

  handleTypeER = (e) => {
    const { value } = e.target;
    this.props.setEventFilters({ ...this.props.eventFilters, typeER: value });
  };

  handleIdentifier = (e) => {
    const { value } = e.target;
    this.props.setEventFilters({
      ...this.props.eventFilters,
      identifier: value,
    });
  };

  exportExcelFile = () => {
    this.props.setLoad(true);
    const workbook = new ExcelJS.Workbook();
    var sheet = workbook.addWorksheet("Eventos filtrados", {
      headerFooter: {
        firstHeader: "Hello Exceljs",
        firstFooter: "Hello World",
      },
    });
    sheet.getColumn("I").width = 20;
    const logoCim =
      "data:image/png;base64,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";
    const logo = workbook.addImage({
      base64: logoCim,
      extension: "PNG",
    });
    var fechaDesde = "";
    var fechaHasta = new Date();
    fechaHasta = moment(fechaHasta).format("DD-MM-YYYY");
    if (this.state.dateIniCre != null) {
      fechaDesde = moment(this.state.dateIniCre).format("DD-MM-YYYY");
    }
    if (this.state.dateEndCre != null) {
      fechaHasta = moment(this.state.dateEndCre).format("DD-MM-YYYY");
    }

    sheet.addImage(logo, "I4:I7");
    const title = sheet.getCell("C1");
    title.value =
      "RECONCILIACIÓN TRIMESTRAL ( " + fechaDesde + " - " + fechaHasta + ")";
    const subtitle = sheet.getCell("A12");
    subtitle.value =
      "Por favor completar ID local del caso, si aplica. En caso de una lista incompleta, agregue los eventos reportables que faltan.";
    const medra = sheet.getCell("A13");
    medra.value = "MedDRA Versión";
    medra.style = { font: { bold: true, name: "Calibri" } };

    const headerRow = sheet.getRow(15);
    headerRow.values = [
      "ID del CIM del evento",
      "ID Licenciante (si aplica)",
      "Fecha de recepción al CIM (Día/Mes/Año)",
      "País del evento",
      "Compañía",
      "Tipo de evento reportable",
      "Tipo del reporte",
      "Reacción/evento",
      "Tipo de Reacción Adversa",
      "Principio activo",
      "Producto",
    ];
    for (var i = 1; i < 12; i++) {
      const titulos = sheet.getRow(1);
      sheet.getCell(15, i).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF87CEFA" },
      };
      sheet.getCell(15, i).border = {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };
    }
    const rowsToInsert = sheet.getRows(16, this.props.data.length);

    var pa;
    for (var i = 0; i < this.props.data.length; i++) {
      const itemData = this.props.data[i];
      const row = rowsToInsert[i];
      var tRAM = "---";
      if (itemData.tipoRAM == "Tipo I") {
        tRAM = "Tipo I - leve en su domicilio";
      }
      if (itemData.tipoRAM == "Tipo II") {
        tRAM = "Tipo II - consulta medica";
      }
      if (itemData.tipoRAM == "Tipo III") {
        tRAM =
          "Tipo III - Consulta médica más síntoma que se prolonga en el tiempo";
      }
      if (itemData.tipoRAM == "Tipo IV") {
        tRAM = "Tipo IV - Peligro de vida, discapacidad o fallecimiento";
      }
      row.values = [
        itemData.origin,
        null,
        moment(itemData.date).format("DD/MM/YYYY"),
        itemData.country,
        itemData.company,
        itemData.type,
        itemData.tipoReporte,
        itemData.Reaccion,
        tRAM,
        itemData.principioActivo,
        itemData.product,
      ];

      /*var y = 16;
            for(var x = 1; x < 12; x++){
                sheet.getCell(y,x).border = {
                    top: {style:'thin', color: {argb:'FF000000'}},
                    left: {style:'thin', color: {argb:'FF000000'}},
                    bottom: {style:'thin', color: {argb:'FF000000'}},
                    right: {style:'thin', color: {argb:'FF000000'}}
                };
            }
            y = y + 1;*/
    }
    sheet.getCell(this.props.data.length + 18, 1).value = "Fecha:";
    sheet.getCell(this.props.data.length + 18, 1).style = {
      font: { bold: true, name: "Calibri" },
    };
    sheet.getCell(this.props.data.length + 19, 1).value = "Firma:";
    sheet.getCell(this.props.data.length + 19, 1).style = {
      font: { bold: true, name: "Calibri" },
    };
    workbook.xlsx.writeBuffer().then(function(data) {
      const blob = new Blob([data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "ListadoEventos.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });

    this.props.setLoad(false);
  };

  render() {
    const {
      codigueras,
      avanced,
      handleAvancedChange,
      handleSearch,
      data,
      headers,
    } = this.props;
    const {
      laboratories,
      companies,
      products,
      pActive,
      hiddenFilters,
      countries,
    } = this.state;
    let dateIniCreFormat, dateEndCreFormat, dateIniModFormat, dateEndModFormat;
    if (this.props.eventFilters.dateIniCre) {
      dateIniCreFormat = moment(this.props.eventFilters.dateIniCre).format(
        "DD/MM/YYYY"
      );
    } else {
      dateIniCreFormat = null;
    }
    if (this.props.eventFilters.dateEndCre) {
      dateEndCreFormat = moment(this.props.eventFilters.dateEndCre).format(
        "DD/MM/YYYY"
      );
    } else {
      dateEndCreFormat = null;
    }
    if (this.props.eventFilters.dateIniMod) {
      dateIniModFormat = moment(this.props.eventFilters.dateIniMod).format(
        "DD/MM/YYYY"
      );
    } else {
      dateIniModFormat = null;
    }
    if (this.props.eventFilters.dateEndMod) {
      dateEndModFormat = moment(this.props.eventFilters.dateEndMod).format(
        "DD/MM/YYYY"
      );
    } else {
      dateEndModFormat = null;
    }
    return (
      <div>
        <Row hidden={hiddenFilters}>
          <Col hidden={this.props.newFilter} xs={6} sm={3}>
            <FieldSelect
              label="País"
              name="country"
              onChange={this.handleChangeCountrie}
              items={countries}
              valueField="Code"
              textField="Name"
              selectedValue={this.props.eventFilters.country}
            />
          </Col>
          <Col hidden={this.props.newFilter} xs={6} sm={3}>
            <FieldSelect
              label="Compañía"
              name="company"
              onChange={this.handleChangeCompany}
              items={companies}
              typeValue="number"
              valueField="CompanyId"
              textField="Company"
              selectedValue={this.props.eventFilters.company}
            />
          </Col>
          <Col hidden={this.props.newFilter} xs={6} sm={3}>
            <FieldSelect
              label="Fabricante"
              name="laboratory"
              onChange={this.handleChangeLab}
              items={laboratories}
              typeValue="number"
              valueField="Id"
              textField="Nombre"
              selectedValue={this.props.eventFilters.laboratory}
            />
          </Col>
          <Col hidden={this.props.newFilter} xs={6} sm={3}>
            <FieldSelect
              label="Producto"
              name="product"
              onChange={this.handleProduct}
              items={products}
              typeValue="text"
              valueField="ComercialName"
              textField="ComercialName"
              selectedValue={this.props.eventFilters.NombreComercial}
            />
          </Col>
          <Col hidden={this.props.newFilter} xs={6} sm={3}>
            <FieldSelect
              label="Estado"
              name="status"
              onChange={this.handleStatus}
              items={codigueras && codigueras.Status}
              typeValue="number"
              valueField="Id"
              textField="Estado"
              selectedValue={this.props.eventFilters.status}
            />
          </Col>
          <Col hidden={this.props.newFilter} xs={6} sm={3}>
            <FieldSelect
              label="Tipo RAM"
              name="typeRAM"
              onChange={this.handleTypeRAM}
              items={codigueras && codigueras.RAMTipos}
              typeValue="number"
              valueField="Id"
              textField="Type"
              selectedValue={this.props.eventFilters.typeRAM}
            />
          </Col>
          <Col hidden={this.props.newFilter} xs={12} sm={3}>
            <FieldSelect
              label="Tipo de Reporte"
              name="typeER"
              onChange={this.handleTypeER}
              items={codigueras && codigueras.SubGrupo}
              typeValue="number"
              valueField="Id"
              textField="Nombre"
              selectedValue={this.props.eventFilters.typeER}
            />
          </Col>
          <Col hidden={this.props.newFilter} xs={6} sm={3}>
            <FieldText
              label="Identificador ER"
              name="identifier"
              onChange={this.handleIdentifier}
              defaultSelectedValue={this.props.eventFilters.identifier}
            />
          </Col>

          <Col hidden={!this.props.newFilter} xs={6} sm={3}>
            <FieldSelect
              label="Producto"
              name="product"
              onChange={this.handleProduct}
              items={products}
              typeValue="text"
              valueField="ComercialName"
              textField="ComercialName"
              selectedValue={this.props.eventFilters.NombreComercial}
            />
          </Col>
          <Col hidden={!this.props.newFilter} xs={12} sm={3}>
            <FieldSelect
              label="Principio activo"
              name="principioActivo"
              onChange={this.handlePActive}
              items={pActive}
              typeValue="text"
              valueField="PrincipioActivo_Nombre"
              textField="PrincipioActivo_Nombre"
              selectedValue={this.props.eventFilters.pActive}
            />
          </Col>
          <Col xs={6} sm={3} hidden={!avanced}>
            <FieldDatePicker
              allowFuture={false}
              allowPast={true}
              label="Fecha de creación desde"
              onChange={(event, value) => {
                this.setState({ dateIniCre: value });
                this.props.setEventFilters({
                  ...this.props.eventFilters,
                  dateIniCre: value,
                });
              }}
              name="startCreate"
              placeholder={dateIniCreFormat}
            />
          </Col>
          <Col xs={6} sm={3} hidden={!avanced}>
            <FieldDatePicker
              allowFuture={false}
              allowPast={true}
              label="Fecha de creación hasta"
              onChange={(event, value) => {
                this.setState({ dateEndCre: value });
                this.props.setEventFilters({
                  ...this.props.eventFilters,
                  dateEndCre: value,
                });
              }}
              name="endCreate"
              placeholder={dateEndCreFormat}
            />
          </Col>
          <Col xs={6} sm={3} hidden={!avanced}>
            <FieldDatePicker
              allowFuture={false}
              allowPast={true}
              label="Fecha de última modificación desde"
              onChange={(event, value) => {
                this.setState({ dateIniMod: value });
                this.props.setEventFilters({
                  ...this.props.eventFilters,
                  dateIniMod: value,
                });
              }}
              name="startUpdate"
              placeholder={dateIniModFormat}
            />
          </Col>
          <Col xs={6} sm={3} hidden={!avanced}>
            <FieldDatePicker
              allowFuture={false}
              allowPast={true}
              label="Fecha de última modificación hasta"
              onChange={(event, value) => {
                if (value < this.state.dateIniMod) event.preventDefault();
                this.props.setEventFilters({
                  ...this.props.eventFilters,
                  dateEndMod: value,
                });
              }}
              name="endUpdate"
              placeholder={dateEndModFormat}
            />
          </Col>
        </Row>
        <Row className="p-l p-r p-b-md">
          <div className="div-button-right">
            <Button
              className="pull-rigth m-r button-back text-primary"
              onClick={handleAvancedChange}
            >
              <FontAwesomeIcon
                className="m-r"
                icon={avanced ? faAngleUp : faAngleDown}
              />
              Busqueda avanzada
              <FontAwesomeIcon className="m-l-sm" icon={faFilter} />
            </Button>
            <Button
              className={`pull-rigth m-r text}`}
              onClick={this.handleHiddenFilters}
            >
              <FontAwesomeIcon
                size="lg"
                className="m-l-sm"
                icon={!hiddenFilters ? faAngleDoubleUp : faAngleDoubleDown}
              />
            </Button>
            <Button
              className="pull-rigth button-next"
              onClick={() => handleSearch(1)}
            >
              <FontAwesomeIcon size="lg" icon={faSearch} />
            </Button>
            &nbsp;
            <Button
              className="pull-rigth button-next"
              disabled={this.props.data.length === 0}
            >
              <FontAwesomeIcon
                size="lg"
                icon={faFileExcel}
                onClick={this.exportExcelFile}
              />
            </Button>
          </div>
        </Row>
      </div>
    );
  }
}

FilterERSearch.propTypes = {
  getProductosFilterSearch: PropTypes.func,
  filters: PropTypes.object,
  codigueras: PropTypes.object,
  codiguerasRAM: PropTypes.object,
};

const validate = (values) => {
  const error = {};
  return error;
};

const mapDispatchToProps = {
  getProductosFilterSearch,
  setLoad,
  showError,
  getFilterSearch,
  setEventFilters,
};

const mapStateToProps = (state) => {
  return {
    filters: getFilterSearch(state),
    codigueras: getCodigueraContext(state),
    codiguerasRAM: getCodigueraRAM(state),
    eventFilters: state.eventFilters,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: "FilterSearch", validate })(FilterERSearch));
